import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "check"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  href: "#contact-view"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "check",
  class: "menu-icon"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-rounded" }, " menu ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "spacer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoNameBrand = _resolveComponent("LogoNameBrand")!
  const _component_MenuComponent = _resolveComponent("MenuComponent")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("header", {
      class: _normalizeClass(["topBar", {'light-topBar': !_ctx.pathIsOptimizeTool, 'dark-topBar': _ctx.pathIsOptimizeTool, 'scroll': _ctx.hasScrolled && _ctx.pathIsOptimizeTool}])
    }, [
      _hoisted_1,
      _createVNode(_component_LogoNameBrand),
      _createVNode(_component_MenuComponent, {
        class: _normalizeClass(["menu", {'dark-menu': _ctx.pathIsOptimizeTool}])
      }, null, 8, ["class"]),
      (_ctx.isRouteHome)
        ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
            _createVNode(_component_ActionButton, {
              class: _normalizeClass({'dark-button': !_ctx.pathIsOptimizeTool, 'light-button': _ctx.pathIsOptimizeTool}),
              text: "Contáctanos"
            }, null, 8, ["class"])
          ]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ActionButton, {
                class: _normalizeClass({'dark-button': !_ctx.pathIsOptimizeTool, 'light-button': _ctx.pathIsOptimizeTool}),
                text: "Contáctanos"
              }, null, 8, ["class"])
            ]),
            _: 1
          })),
      _hoisted_3
    ], 2), [
      [_vShow, !_ctx.isInFrame]
    ]),
    (!_ctx.isInFrame)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}